import React from 'react';
import Logo from '../layout/Logo';

type Props = {
  children: React.ReactNode;
};

const LoginContainer: React.FC<Props> = ({ children }) => {
  return (
    <div className="min-h-screen bg-white dark:bg-darkGray-900 flex p-6">
      <div className="mx-auto w-full max-w-sm lg:w-96 self-center">
        <a href="https://chiroup.com" target="_blank" rel="noreferrer">
          <Logo className="h-16 w-auto" />
        </a>
        {children}
      </div>
    </div>
  );
};

export default LoginContainer;
